/**
 * Returns true when the dispatch date string includes an explicit time (ISO datetime).
 * Examples:
 * - Date-only: 2026-05-14
 * - DateTime: 2026-05-14T14:30:00
 */
export const includesTimeOfDay = (dateString) => {
    return dateString.includes("T");
};
